import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Stepper(theme: Theme) {
  return {
    MuiStepButton: {
      styleOverrides: {
        horizontal: {
          display: 'flex',
        },
      },
    },
  }
}
